// interviewBaseQuery.ts

import {
  fetchBaseQuery,
  type BaseQueryFn,
  type FetchArgs,
  type FetchBaseQueryError,
} from "@reduxjs/toolkit/query";

/**
 * BaseQuery for Interview Portal
 * Uses hash token from URL only
 */
export const createInterviewBaseQuery = (
  baseUrl: string,
): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> => {
  const baseQuery = fetchBaseQuery({
    baseUrl,
    credentials: "include", // no cookies needed
  });

  return async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);

    

    return result;
  };
};
